// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ====== Container ====== */
.carousel-container {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  height: 137px;
  border-top: 0.07rem solid hsla(0, 0%, 100%, 0.3);
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  z-index: 5;
}

/* ====== Wrapper ====== */
.carousel {
  position: relative;
  width: 100%;
}

/* main line */
.carousel-track-line {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.35);
  border-radius: 999px;
  pointer-events: none;
}

/* ====== Logos scroller ====== */
.carousel-logos {
  display: flex;
  flex-direction: row;        /* always LTR internally */
  direction: ltr;             /* always LTR internally */
  overflow-x: auto;
  overflow-y: visible;
  scroll-behavior: smooth;
  scrollbar-width: none;
  justify-content: center;
  position: relative;
  padding-bottom: 0;
}

/*  */

.carousel-logos::-webkit-scrollbar {
  display: none;
}

/* ====== Items ====== */
.carousel-item {
  width: 103px;
  height: 103px;
  margin: 0 10px;
  background-color: #111;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: visible;
  transition: all 0.15s ease-in-out;
  position: relative;
  flex: 0 0 auto;
}

.carousel-item > img {
  opacity: 0.5;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: white;
  padding: 4px;
}

.carousel-item.active > img {
  opacity: 1;
}

.carousel-item.active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -12px;
  width: 40px;
  height: 4px;
  transform: translateX(-50%);
  background: #fff;
  border-radius: 999px;
  pointer-events: none;
}

.carousel-item:active {
  transform: scale(0.95);
}

.carousel-item:hover > img {
  opacity: 1;
}

/* ====== Tablet ====== */
@media (min-width: 768px) and (max-width: 991px) {
  .carousel-container {
    height: 120px;
    width: 100vw;
    left: 0;
    right: 0;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
    backdrop-filter: none;
    overflow: visible;
    z-index: 99999;
    border-top: 0.07rem solid hsla(0, 0%, 100%, 0.3);
  }

  .carousel-container > div {
    padding-bottom: 0 !important;
  } 

  .carousel-logos {
    justify-content: flex-start;
    overflow-x: auto;
    overflow-y: visible;
    padding-left: 96px;
    padding-right: 48px;
    padding-bottom: 0;
  }
html[dir='rtl'] .carousel-logos{
  padding-right: 96px;
  padding-left: 48px;
}
  .carousel-item {
    width: 93px;
    height: 93px;
    margin: 0 6px;
  }
}

@media (min-width: 768px) {
  .carousel-item.active::after,
  .carousel-track-line {
    display: none;
  }
}

/* ====== Mobile ====== */
@media (max-width: 767px) {
  .carousel-container {
    height: 120px;
    width: 100vw;
    left: 0;
    right: 0;
    margin-left: 0;
    margin-right: 0;
    padding-left: 8px;
    padding-right: 8px;
    backdrop-filter: none;
    border-top: none;
    overflow: visible;
    z-index: 99999;
  }

  .carousel-logos {
    justify-content: flex-start;
    overflow-x: auto;
    overflow-y: visible;
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 24px;
  }

  .carousel-item {
    width: 90px;
    height: 90px;
    margin: 0 6px;
  }

  .carousel-item.active::after {
    bottom: -18px;
    width: 40px;
    height: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/Carousel.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,UAAU;AACZ;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB,SAAS,0BAA0B;EACtD,cAAc,cAAc,0BAA0B;EACtD,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,KAAK;;AAEL;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;IACb,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,cAAc;IACd,gDAAgD;EAClD;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;AACF;EACE,mBAAmB;EACnB,kBAAkB;AACpB;EACE;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;IACb,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;IACX,WAAW;EACb;AACF","sourcesContent":["/* ====== Container ====== */\n.carousel-container {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 137px;\n  border-top: 0.07rem solid hsla(0, 0%, 100%, 0.3);\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  z-index: 5;\n}\n\n/* ====== Wrapper ====== */\n.carousel {\n  position: relative;\n  width: 100%;\n}\n\n/* main line */\n.carousel-track-line {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 5px;\n  height: 5px;\n  background: rgba(255, 255, 255, 0.35);\n  border-radius: 999px;\n  pointer-events: none;\n}\n\n/* ====== Logos scroller ====== */\n.carousel-logos {\n  display: flex;\n  flex-direction: row;        /* always LTR internally */\n  direction: ltr;             /* always LTR internally */\n  overflow-x: auto;\n  overflow-y: visible;\n  scroll-behavior: smooth;\n  scrollbar-width: none;\n  justify-content: center;\n  position: relative;\n  padding-bottom: 0;\n}\n\n/*  */\n\n.carousel-logos::-webkit-scrollbar {\n  display: none;\n}\n\n/* ====== Items ====== */\n.carousel-item {\n  width: 103px;\n  height: 103px;\n  margin: 0 10px;\n  background-color: #111;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  overflow: visible;\n  transition: all 0.15s ease-in-out;\n  position: relative;\n  flex: 0 0 auto;\n}\n\n.carousel-item > img {\n  opacity: 0.5;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background-color: white;\n  padding: 4px;\n}\n\n.carousel-item.active > img {\n  opacity: 1;\n}\n\n.carousel-item.active::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: -12px;\n  width: 40px;\n  height: 4px;\n  transform: translateX(-50%);\n  background: #fff;\n  border-radius: 999px;\n  pointer-events: none;\n}\n\n.carousel-item:active {\n  transform: scale(0.95);\n}\n\n.carousel-item:hover > img {\n  opacity: 1;\n}\n\n/* ====== Tablet ====== */\n@media (min-width: 768px) and (max-width: 991px) {\n  .carousel-container {\n    height: 120px;\n    width: 100vw;\n    left: 0;\n    right: 0;\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 0;\n    padding-right: 0;\n    backdrop-filter: none;\n    overflow: visible;\n    z-index: 99999;\n    border-top: 0.07rem solid hsla(0, 0%, 100%, 0.3);\n  }\n\n  .carousel-container > div {\n    padding-bottom: 0 !important;\n  } \n\n  .carousel-logos {\n    justify-content: flex-start;\n    overflow-x: auto;\n    overflow-y: visible;\n    padding-left: 96px;\n    padding-right: 48px;\n    padding-bottom: 0;\n  }\nhtml[dir='rtl'] .carousel-logos{\n  padding-right: 96px;\n  padding-left: 48px;\n}\n  .carousel-item {\n    width: 93px;\n    height: 93px;\n    margin: 0 6px;\n  }\n}\n\n@media (min-width: 768px) {\n  .carousel-item.active::after,\n  .carousel-track-line {\n    display: none;\n  }\n}\n\n/* ====== Mobile ====== */\n@media (max-width: 767px) {\n  .carousel-container {\n    height: 120px;\n    width: 100vw;\n    left: 0;\n    right: 0;\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 8px;\n    padding-right: 8px;\n    backdrop-filter: none;\n    border-top: none;\n    overflow: visible;\n    z-index: 99999;\n  }\n\n  .carousel-logos {\n    justify-content: flex-start;\n    overflow-x: auto;\n    overflow-y: visible;\n    padding-left: 0;\n    padding-right: 0;\n    padding-bottom: 24px;\n  }\n\n  .carousel-item {\n    width: 90px;\n    height: 90px;\n    margin: 0 6px;\n  }\n\n  .carousel-item.active::after {\n    bottom: -18px;\n    width: 40px;\n    height: 4px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
